import { motion } from "framer-motion";
import { Brain, Palette, ShoppingBasket, MessagesSquare, ArrowUpRight } from "lucide-react";

export const SERVICES = [
  { key: "Mental health", icon: Brain, title: "Mental health support", text: "Culturally safe social and emotional wellbeing support, and help connecting with health services.", color: "bg-gum text-sand" },
  { key: "Counselling", icon: MessagesSquare, title: "Counselling", text: "Talk one-on-one, confidentially, with someone who understands culture, family and community. [Add provider/qualification details]", color: "bg-ink text-sand" },
  { key: "Food hamper", icon: ShoppingBasket, title: "Food hampers", text: "Food relief hampers for individuals and families doing it tough. [Add pick-up/delivery details]", color: "bg-ochre text-sand" },
  { key: "Art therapy", icon: Palette, title: "Art therapy", text: "Heal and express through painting, weaving and creative practice — one-on-one or in group sessions.", color: "bg-sand-2 text-ink" },
];

export const Services = ({ onRequest }) => (
  <div data-testid="services-grid" className="grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
    {SERVICES.map((s, i) => (
      <motion.div
        key={s.key}
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.15 }}
        transition={{ duration: 0.8, delay: i * 0.08, ease: [0.22, 1, 0.36, 1] }}
        whileHover={{ y: -8 }}
        className={`flex min-h-[340px] flex-col rounded-[28px] p-8 ${s.color}`}
      >
        <s.icon className="h-9 w-9" strokeWidth={1.4} />
        <h3 className="mt-8 font-display text-3xl font-medium leading-none">{s.title}</h3>
        <p className="mt-4 text-sm leading-relaxed opacity-85">{s.text}</p>
        {onRequest && (
          <button
            data-testid={`service-request-${s.key.toLowerCase().replace(/\s+/g, "-")}`}
            onClick={() => onRequest(s.key)}
            className="mt-auto flex items-center gap-2 pt-8 text-sm font-semibold underline-offset-4 hover:underline"
          >
            Request privately <ArrowUpRight className="h-4 w-4" />
          </button>
        )}
      </motion.div>
    ))}
  </div>
);
